import * as api from "util/api";

export const getValidMonths = async () => {
    try {
        const { success, data, message } = await api.json.get(
            "api/calendar/metadata/getmonthrange",
        );

        if (!success) {
            throw message;
        }

        return data;
    } catch {
        // nothing
    }

    return [];
};
